import { useContext } from "react";
import { AppContext } from "../App";
import fullLogo from "../assets/full_logo.png";
import { FaArrowRight, FaPhoneAlt } from "react-icons/fa";
import { COMPANY_PHONE, navItems } from "../siteData";

export default function TopBar() {
  const appContext = useContext(AppContext);

  return (
    <header className="TopBar" data-scrolled={appContext.isScrolled}>
      <div className="container">
        <div className="topbar-shell">
          <button
            className="topbar-brand"
            onClick={() => appContext.navTo({ item: "home" })}
            aria-label="Go to home page"
          >
            <img src={fullLogo} alt="MS Universal Distributors" />
          </button>

          <nav className="DesktopMenu d-none d-md-flex align-items-center">
            {navItems.map((nav) => (
              <button
                key={nav.item}
                className="mMenuItem"
                data-active={
                  nav.item === "home"
                    ? !appContext.navItem || appContext.navItem === "home"
                    : appContext.navItem === nav.item
                }
                onClick={() => appContext.navTo({ item: nav.item })}
              >
                {nav.label}
              </button>
            ))}
          </nav>

          <div className="topbar-actions d-none d-lg-flex">
            <a href="tel:+255658902790" className="topbar-contact-link">
              <FaPhoneAlt />
              <span>{COMPANY_PHONE}</span>
            </a>
            <button
              className="btn btn-primary topbar-cta"
              onClick={() => appContext.navTo({ item: "contact_us" })}
            >
              Let&apos;s Talk
              <FaArrowRight />
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
